import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import { apiRequest, formatPrice } from "../../api/client";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (status) params.set("status", status);
    apiRequest(`/api/orders?${params.toString()}`, { tokenType: "admin" })
      .then((response) => setOrders(response.data))
      .finally(() => setLoading(false));
  }, [search, status]);

  useEffect(load, [load]);

  return (
    <div className="admin-page">
      <div className="admin-page-head"><div><span className="eyebrow">Sales</span><h1>Orders</h1></div></div>
      <div className="admin-filters">
        <input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search name, email, order number" />
        <select value={status} onChange={(event) => setStatus(event.target.value)}>
          <option value="">All statuses</option>
          <option value="pending">Pending</option>
          <option value="paid">Paid</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
          <option value="refunded">Refunded</option>
        </select>
        <Button type="button" variant="secondary" onClick={load}>Filter</Button>
      </div>
      {loading ? <LoadingSpinner /> : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead><tr><th>Order</th><th>Customer</th><th>Payment</th><th>Status</th><th>Total</th><th /></tr></thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <td><strong>{order.order_number}</strong><small>{new Date(order.created_at).toLocaleDateString()}</small></td>
                  <td><strong>{order.customer_name}</strong><small>{order.customer_email}</small></td>
                  <td>{order.payment_method}</td>
                  <td><span className={`status-pill status-${order.order_status}`}>{order.order_status}</span></td>
                  <td>{formatPrice(order.total)}</td>
                  <td className="table-actions"><Link to={`/admin/orders/${order.id}`}>Details</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
